import { cookieUtils } from 'helpers/cookiesUtils';
import { Navigate } from 'react-router-dom';

/**
 * @param {object} props
 * @param {'admin' | 'masseuse'} props.auth
 * @param {React.ReactNode} props.element
 * @returns
 */
function PrivateRoute({ auth, element }) {
    const cookies = cookieUtils.getCookies();
    const role = cookies?.user?.role;

    if (role !== auth) {
        const loginPath = auth === 'admin' ? '/auth' : '/auth-therapist';

        return <Navigate to={loginPath} replace />;
    }
    return element;
}

export default PrivateRoute;
